module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-33.3a737839.png";